import { faPlusCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { State, toODataString } from "@progress/kendo-data-query";
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { downloadExcel, initialDataState, pageSizes, successToastr } from '../../../../HelperMethods';
import Auth from '../../../Auth';
import { CREATE_REPORT_PERMISSION } from '../../../Shared/ApiUrls';
import ColumnMenu from '../../../Shared/GridComponents/ColumnMenu';
import { CellRender, GridNoRecord, StatusCell } from '../../../Shared/GridComponents/CommonComponents';
import CompleteSearch from '../../../Shared/Search/CompleteSearch';
import RowActions from '../../../Shared/Workflow/RowActions';
import { history } from "../../../../HelperMethods";
import ConfirmationModal from '../../../Shared/ConfirmationModal';
import { REMOVE_REPORT_PERMISSION_CONFIRMATION_MSG, EXCEL_DOWNLOAD_INPROGRESS, REPORT_PERMISSION_DELETED_SUCCESS_MSG as REPORT_PERMISSION_REMOVED_SUCCESS_MSG, ACTIVE_REPORT_PERMISSION_CONFIRMATION_MSG, REPORT_PERMISSION_ACTIVE_SUCCESS_MSG, REPORT_PERMISSION_DEACTIVATE_SUCCESS_MSG, DEACTIVATE_REPORT_PERMISSION_CONFIRMATION_MSG, } from '../../../Shared/AppMessages';
import { CustomMenu, DefaultActions, DetailColumnCell, ViewMoreComponent } from './GlobalActions';
import BreadCrumbs from '../../../Shared/BreadCrumbs/BreadCrumbs';
import { AppPermissions } from '../../../Shared/Constants/AppPermissions';
import ReportingPermissionDataService from './../../Services/PermissionDataServices';
import { PageName, EntityType, PageId } from '../../../Shared/AppConstants';

export interface ManageReportPremissionProps { }

export interface ManageReportPremissionState {
    onFirstLoad: boolean;
    showLoader: boolean;
    reportPermissionRecords: any;
    totalCount?: number;
    dataState: any;
    showRemoveModal?: boolean;
    showActivateModal?: boolean;
    showDeactivateModal?: boolean;
}

class ManageReportPremission extends React.Component<ManageReportPremissionProps, ManageReportPremissionState> {
    public dataItem: any;
    constructor(props: ManageReportPremissionProps) {
        super(props);
        this.state = {
            onFirstLoad: true,
            showLoader: true,
            reportPermissionRecords: [],
            dataState: initialDataState,
        };
    }

    componentDidMount() {}

    getReportPremission = (dataState) => {

        this.setState({ showLoader: true, onFirstLoad: false });
        var queryStr = `${toODataString(dataState)}`;

        ReportingPermissionDataService.getReportPremission(queryStr).then((res) => {
            this.setState({
                reportPermissionRecords: res.data.items,
                totalCount: res.data.count,
                showLoader: false,
                dataState: dataState,
            });
        });
    }

    onDataStateChange = (changeEvent) => {
        this.getReportPremission(changeEvent.dataState);
        localStorage.setItem("ManageReportPermission-GridDataState", JSON.stringify(changeEvent.dataState));
    };

    handleActionClick = (action, actionId, rowId, nextStateId?, eventName?, dataItem?) => {
        let change = {};
        let property = `show${action.replace(/ +/g, "").replace(".", "")}Modal`;
        change[property] = true;
        this.setState(change);
        this.dataItem = dataItem;
    }

    ExpandCell = (props) => <DetailColumnCell {...props} expandChange={this.expandChange.bind(this)} />;

    expandChange = (dataItem) => {
        const { reportPermissionRecords: data } = this.state;
        const rptPermData = data.map((item) => {
            if (item === dataItem) {
                item.expanded = !item.expanded;
            }
            return item;
        });
        this.setState({
            reportPermissionRecords: rptPermData
        });
    };

    removeReportPremission = (id, statusId, msg) => {
        this.setState({ showRemoveModal: false, showDeactivateModal: false, showActivateModal: false });
        ReportingPermissionDataService.deleteReportPermission(id, statusId).then((res) => {
            successToastr(msg);
            this.getReportPremission(this.state.dataState);
        });
    };

    updateReportPermissionStatus = (id, statusId, msg) => {
        var data = {
            ReportPremissionId: id,
            statusId: statusId
        }
        ReportingPermissionDataService.patchReportPermission(data).then((res) => {
            successToastr(msg);
            this.getReportPremission(this.state.dataState);
        })
    }

    downloadReportPermissionExcel = () => {
       var finalState: State = {
               ...this.state.dataState,
               take: null,
               skip: 0,
           };

        successToastr(EXCEL_DOWNLOAD_INPROGRESS);

        var queryStr = `${toODataString(finalState, { utcDates: true })}`;

        ReportingPermissionDataService.getReportPermissionForExcel(queryStr).then((res: any) => {
            if (res) {
                downloadExcel("Report Permissions.xlsx", res.data);
            }
        });
    }

    render() {
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0">
                <div className="container-fluid mt-3 mb-3 d-md-block d-none">
                    <div className="row pt-2 pb-2 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-10 col-md-6 fonFifteen paddingLeftandRight">
                            <BreadCrumbs></BreadCrumbs>
                        </div>
                        <div className="col-2 col-md-6">
                            {Auth.hasPermissionV2(AppPermissions.REPORT_PERMISSION_CREATE) && (
                                <Link to={CREATE_REPORT_PERMISSION}>
                                    <span className="float-right text-dark">
                                        <FontAwesomeIcon icon={faPlusCircle} className={"mr-1 text-dark"} />
                                        Add New Report Permission
                                    </span>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <CompleteSearch
                        page={PageName.ManageReportPermission}
                        pageId={PageId.ManageReportPermission}
                        entityType={EntityType.REPORTPERMISSION}
                        placeholder="Search text here!"
                        handleSearch={this.getReportPremission}
                        onFirstLoad={this.state.onFirstLoad}
                        persistSearchData={true}
                    />
                    <div className="reportPermissionContainer global-action-grid">
                        <Grid
                            style={{ height: "auto" }}
                            sortable={true}
                            onDataStateChange={this.onDataStateChange}
                            pageable={{ pageSizes: pageSizes }}
                            data={this.state.reportPermissionRecords}
                            {...this.state.dataState}
                            detail={ViewMoreComponent}
                            expandField="expanded"
                            total={this.state.totalCount}
                            className="kendo-grid-custom k-widget lastchild"
                        >
                            <GridNoRecords>{GridNoRecord(this.state.showLoader)}</GridNoRecords>
                            <GridColumn
                                field="reportName"
                                title="Report Name"
                                cell={(props) => CellRender(props, "Report Name")}
                                columnMenu={ColumnMenu}
                                filter="text"
                                width="290px"
                            />
                            <GridColumn
                                field="category"
                                title="Category"
                                cell={(props) => CellRender(props, "Category")}
                                columnMenu={ColumnMenu}
                                filter="text"
                            />
                            <GridColumn
                                field="createdByName"
                                title="Created By"
                                cell={(props) => CellRender(props, "Created By")}
                                columnMenu={ColumnMenu}
                                filter="text"
                            />
                            <GridColumn
                                field="createdDate"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                title="Created Date"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Report Permission", null, true)}
                            />
                            <GridColumn
                                field="status"
                                title="Status"
                                columnMenu={ColumnMenu}
                                cell={StatusCell}
                            />
                            <GridColumn
                                title="Action"
                                sortable={false}
                                width="70px"
                                cell={(props) => {
                                    return (
                                        <RowActions
                                            dataItem={props.dataItem}
                                            currentState={""}
                                            rowId={props.dataItem.reportPermissionId}
                                            handleClick={this.handleActionClick}
                                            defaultActions={DefaultActions(props)}
                                        />
                                    )
                                }}
                                headerCell={() => CustomMenu(this.downloadReportPermissionExcel)}
                            />
                            <GridColumn sortable={false} field="expanded" width="100px" title="View More" cell={this.ExpandCell} />
                        </Grid>
                        <div className="modal-footer justify-content-center border-0">
                            <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                                <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => history.goBack()}>
                                    <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                                </button>
                            </div>
                        </div>
                    </div>
                    <ConfirmationModal
                        message={REMOVE_REPORT_PERMISSION_CONFIRMATION_MSG()}
                        showModal={this.state.showRemoveModal}
                        handleYes={() => this.removeReportPremission(this.dataItem.reportPermissionId, 2, REPORT_PERMISSION_REMOVED_SUCCESS_MSG)}
                        handleNo={() => {
                            this.setState({ showRemoveModal: false });
                        }}
                    />
                    <ConfirmationModal
                        message={ACTIVE_REPORT_PERMISSION_CONFIRMATION_MSG()}
                        showModal={this.state.showActivateModal}
                        handleYes={() => this.removeReportPremission(this.dataItem.reportPermissionId, 1, REPORT_PERMISSION_ACTIVE_SUCCESS_MSG)}
                        handleNo={() => {
                            this.setState({ showActivateModal: false });
                        }}
                    />
                    <ConfirmationModal
                        message={DEACTIVATE_REPORT_PERMISSION_CONFIRMATION_MSG()}
                        showModal={this.state.showDeactivateModal}
                        handleYes={() => this.removeReportPremission(this.dataItem.reportPermissionId, 0, REPORT_PERMISSION_DEACTIVATE_SUCCESS_MSG)}
                        handleNo={() => {
                            this.setState({ showDeactivateModal: false });
                        }}
                    />
                </div>
            </div>
        )

    }
}
export default ManageReportPremission;